import fetch from "auth/FetchInterceptor";

const AdminschoolService = {};

AdminschoolService.getStatistics = async () =>
  await fetch("/adminSchool/statistics", {
    method: "GET",
  });

AdminschoolService.getFormationsRevenue = async ({
  granularity,
  type,
  name,
  year,
  month,
  currency,
}) =>
  await fetch("/adminSchool/getFormationsRevenue", {
    method: "GET",
    params: {
      granularity,
      type,
      name,
      year: granularity !== "monthly" ? undefined : year,
      month,
      currency,
    },
  });

AdminschoolService.getSupportCoursesRevenue = async ({
  granularity,
  type,
  name,
  year,
  month,
}) =>
  await fetch("/adminSchool/getSupportCoursesRevenue", {
    method: "GET",
    params: {
      granularity,
      type,
      name,
      year: granularity !== "monthly" ? undefined : year,
      month,
    },
  });

AdminschoolService.getExpenses = async ({ granularity, year, month }) =>
  await fetch("/adminSchool/getExpenses", {
    method: "GET",
    params: {
      granularity,
      year: granularity !== "monthly" ? undefined : year,
      month,
    },
  });

AdminschoolService.getFinanceSummary = async ({ currency }) =>
  await fetch("/adminSchool/finance-summary", {
    method: "GET",
    params: { currency },
  });

AdminschoolService.resetFinanceCounters = async () =>
  await fetch("/adminSchool/finance-reset", {
    method: "POST",
  });

AdminschoolService.getSubscriptionStatistics = async () =>
  await fetch("/adminSchool/subscription-statistics", {
    method: "GET",
  });

export default AdminschoolService;
